import { type FunctionComponent } from 'preact'
import { html } from 'htm/preact'
import type { AppState } from '../../state.js'
import { ToolPage, Disclaimer } from '../../components/tool-page.js'
import { findRefrigerantBySlug } from '../../util/refrigerant-phaseout.js'
import './refrigerant-detail.css'

export const RefrigerantDetail:FunctionComponent<{
    state:AppState;
    params:{ slug?:string };
}> = function RefrigerantDetail ({ params }) {
    const slug = params?.slug ?? ''
    const item = slug ? findRefrigerantBySlug(slug) : undefined

    if (!item) {
        return html`
            <${ToolPage} title="Refrigerant not found">
                <div class="refrigerant-detail">
                    <p class="ref-detail-notfound">
                        We couldn't find a refrigerant matching
                        "${slug}".
                    </p>
                    <a
                        class="ref-detail-back"
                        href="/tools/refrigerant-phaseout"
                    >← Back to refrigerant lookup</a>
                </div>
            </${ToolPage}>
        `
    }

    return html`
        <${ToolPage} title=${item.name}>
            <div class="refrigerant-detail">
                <a
                    class="ref-detail-back"
                    href="/tools/refrigerant-phaseout"
                >← Back to refrigerant lookup</a>

                <dl class="ref-detail-spec">
                    <dt>Aliases</dt>
                    <dd>${item.aliases.join(', ') || 'None'}</dd>
                    <dt>Category</dt>
                    <dd>${item.category}</dd>
                    <dt>Status</dt>
                    <dd>${item.status}</dd>
                    <dt>GWP</dt>
                    <dd>${item.gwp}</dd>
                    <dt>ODP</dt>
                    <dd>${item.odp}</dd>
                    <dt>Safety Class</dt>
                    <dd>${item.safetyClass}</dd>
                    <dt>Approved Substitutes</dt>
                    <dd>
                        ${item.approvedSubstitutes.join(', ') ||
                            'None listed'}
                    </dd>
                    <dt>Summary</dt>
                    <dd>${item.summary}</dd>
                </dl>

                <${Disclaimer} />
            </div>
        </${ToolPage}>
    `
}
